import { Component } from '@angular/core';

/**
 * This component is never visited.
 * The canActivate will remove the production/# part from the url.
 * The route requires a Component, therefore this component is necessary.
 */
@Component({
  selector: 'app-production-redirect',
  template: '<div>404</div>'
})
export class ProductionRedirectComponent {}
